import Immutable from 'immutable'

export const SignupProgressRecord = Immutable.Record(
  {
    accountCompleted: false,
    accountError: false,
    addressCompleted: false,
    addressError: false,
    canAdvanceToAccount: false,
    canAdvanceToAddress: true,
    canAdvanceToOffer: true,
    canAdvanceToDetail: false,
    canAdvanceToSummary: false,
    detailCompleted: false,
    detailError: false,
    offerCompleted: false,
    offerError: false,
    page: '',
    summaryCompleted: false,
    summaryError: false,
  },
  'SignupProgress',
)

const accountFields = [
  'firstName',
  'lastName',
  'email',
  'emailConfirm',
  'userPassword',
  'contact',
  'dateOfBirth',
  'challengePhrase',
]
const summaryFields = [
  'couponCode',
  'card.number',
  'card.name',
  'card.expiryMonth',
  'card.expiryYear',
  'card.cvn',
]

/**
 * Page can be: 'offer', 'account', 'detail', 'summary'
 */
export default function createSignupProgress(
  signupWithExternals,
  errors = Immutable.Set(),
  page,
) {
  const signup = signupWithExternals.signup

  return new SignupProgressRecord({
    accountCompleted: page === 'detail' || page === 'summary',
    accountError: errors.some(e => accountFields.indexOf(e.path) >= 0),
    addressCompleted: true,
    addressError: errors.some(e => e.path === 'address'),
    canAdvanceToAccount: !!signupWithExternals.offer,
    canAdvanceToDetail: page === 'detail' || page === 'summary',
    detailCompleted: page === 'summary',
    detailError: errors.some(e => e.path.match(/^data\[/)),
    offerCompleted: !!signupWithExternals.offer,
    page,
    summaryCompleted: signup.state !== 'new',
    summaryError: errors.some(e => summaryFields.indexOf(e.path) >= 0),
  })
}



// WEBPACK FOOTER //
// ./src/records/SignupProgress.js